import {Task} from "../../shared/models/task.model";
import {DayInformation} from "../../shared/models/day-information.model";

export function sortCategoriesAndTasks(unsorted: Map<string, Task[]>) {
    unsorted.forEach((value: Task[], key: string) => {
        //  best(0), good(1), bad(2), worst(3);
        const sortedTasks = value.sort((a, b) => {
            if (a.weight === b.weight) {
                return a.header > b.header ? 1 : -1;
            }

            if (a.weight === 'neutral') {
                return 1;
            }
            if (b.weight === 'neutral') {
                return -1;
            }

            if (a.weight === 'best' || b.weight === 'worst') {
                return -1;
            }
            if (b.weight === 'best' || a.weight === 'worst') {
                return 1;
            }
            if (a.weight === 'good' && b.weight === 'bad') {
                return -1;
            }

            return 0;
        });

        unsorted.set(key, sortedTasks);
    });

    return new Map<string, Task[]>(
        [...unsorted].sort((a, b) =>
            a[0].localeCompare(b[0])
        )
    );

}

export function getAllCategories(dayInformation: DayInformation) {
    const tasksForDay = dayInformation.sign.tasks;

    const allCategories: string[] = [];

    for (const task of tasksForDay) {
        const categoryId = task.category.name;
        if (!allCategories.includes(categoryId)) {
            allCategories.push(categoryId);
        }
    }

    return allCategories;
}
